// extracted by mini-css-extract-plugin
module.exports = {"root":"Drawer_root__DHfip","temporary":"Drawer_temporary__3G4Ld","left":"Drawer_left__1kRbA","right":"Drawer_right__1g_ay"};